import script from "./EmployeesList.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesList.vue?vue&type=script&setup=true&lang=js"

import "./EmployeesList.vue?vue&type=style&index=0&id=1e13b366&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e13b366"]])

export default __exports__